<script>
import moment from "moment";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";

export default {
  components: {Footer, Header },
  data() {
    return {
      menuproduk: 1,
      currentTab: 0,
      tabs: ["Menu 1", "Menu 2", "Menu 3"],
      activeItem: "home",
      class_start: moment("2021-07-12 +07:00", "YYYY-MM-DD ZZ"),
    };
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },

  methods: {
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (
        document.body.scrollTop >= 50 ||
        document.documentElement.scrollTop >= 50
      ) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },

    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    nextSlide() {
      this.USDrefs.carousel.goToPage(this.USDrefs.carousel.getNextPage());
    },
    prevSlide() {
      this.USDrefs.carousel.goToPage(this.USDrefs.carousel.getPreviousPage());
    },
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },

    onGoing() {
      this.$router.push({ name: "registration" });
    },
  },
};
</script>

<style scoped>
.overlay-panel-actions-primary {
  display: flex;
  flex-wrap: wrap;
  background: pink;
  padding: 10px;
  margin-bottom: 10px;
}

.overlay-panel-actions-primary li {
  width: 50%;
  display: block;
  text-align: center;
  padding: 0 10px;
}

#home-header {
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("https://api.paideia.id/api/files/public/690cc718ce9444c6bfbd72c7d003141csettingancoverbgcovecoders.png");
}

.hero-section {
  width: 100%;
  height: 853px;
}

#after-banner {
  height: 700px;
  padding: 0px 50px 0px 50px;
}

.image-home {
  width: auto;
  height: auto;
  margin-right: 150px;
}

@media only screen and (min-width: 1440px) {
  #home-header {
    width: 100%;
    height: 1180px;
    background-repeat: no-repeat;
    background-size: cover;
    padding: auto;
    background-image: url("https://api.paideia.id/api/files/public/690cc718ce9444c6bfbd72c7d003141csettingancoverbgcovecoders.png");
  }

  .image-home {
    width: 52vw;
    height: 52vw;
    margin-left: 50px;
  }
}

@media (max-width: 991px) {
  .hero-section {
    width: 100%;
    height: auto;
  }

  .image-home {
    width: 80vw;
    height: 80vw;
    margin-left: 8px;
    display: flex;
    justify-content: center;
  }
}

@media only screen and (max-width: 700px) {
  .hero-section {
    width: 100%;
    height: auto !important;
    margin: 0px 0px 0px 0px;
  }

  #home-header {
    height: 500px;
    padding: 90px 0px 10px 0px;
    margin: auto;
  }

  .image-home {
    width: 90vw;
    height: 90vw;
    margin-left: 8px;
    display: flex;
    justify-content: center;
  }
}

.after-reasons .kutip1 {
  margin-bottom: 50px;
  margin-left: -60px;
}

.after-reasons .kutip2 {
  position: absolute;
  z-index: 1;
  right: 90px;
  bottom: -10px;
}

@media only screen and (max-width: 700px) {
  .after-reasons .kutip1 {
    margin: 50px 0px 0px -10px;
    width: 10vw;
    height: 7vw;
  }

  .after-reasons .kutip2 {
    position: absolute;
    width: 10vw;
    height: 7vw;
    z-index: 1;
    right: 0px;
    bottom: 10px;
  }
}

.after-banner {
  position: relative;
  width: 100%;
  height: auto;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("https://api.paideia.id/api/files/public/e4c91bd22d7947ce89c5487280b55cb5Vector3.png");
}

#action .wrapper-thumbnail .thumbnail-icon h2 {
  font-size: 31px;
  color: #ffffff;
}

#action .wrapper-thumbnail .thumbnail-icon p {
  font-size: 20px;
  color: #ffffff;
}

#action .wrapper-thumbnail .thumbnail-icon .thumbnail {
  margin: 0 23px;
  padding: 0;
  color: #2e2e2e;
  font-family: "PoppinsLight";
  position: relative;
  display: block;
  z-index: 1;
}

#action .wrapper-thumbnail .thumbnail-icon .thumbnail:after {
  content: "";
  position: absolute;
  left: 0;
  width: 0%;
  background: #ffffff;
  height: 3px;
  bottom: 8px;
  border: 0;
  margin: 0;
}

#action .wrapper-thumbnail .thumbnail-icon .thumbnail:hover,
#action .wrapper-thumbnail .thumbnail-icon .thumbnail:focus,
#action .wrapper-thumbnail .thumbnail-icon .thumbnail.active {
  font-family: "PoppinsSemiBold";
  color: #ffffff;
}

#action .wrapper-thumbnail .thumbnail-icon .thumbnail:hover:after,
#action .wrapper-thumbnail .thumbnail-icon .thumbnail:focus:after,
#action .wrapper-thumbnail .thumbnail-icon .thumbnail.active:after {
  width: 100%;
}

#action .wrapper-thumbnail .thumbnail-icon {
  display: flex;
  justify-content: space-around;
  margin: 0px 0px 0px 0px;
}

#action .thumbnail {
  text-align: center;
  margin: 0px 80px 0px 0px;
  cursor: pointer;
}

#action .buttom-text {
  display: flex;
  justify-content: center;
  margin: 15px 0px 10px 0px;
}

#action .buttom-text .text h3 {
  font-size: 45px;
  color: #ffffff;
  font-family: "PoppinsBold";
  text-shadow: 0px 2px 2px rgba(103, 103, 103, 20);
}

#action .buttom-text .text p {
  font-size: 20px;
  color: #ffffff;
  font-family: "PoppinsBold";
  margin-top: -5px;
  letter-spacing: 1px;
  text-shadow: 0px 2px 2px rgba(103, 103, 103, 20);
}

@media only screen and (max-width: 700px) {
  #action .buttom-text .text {
    margin: auto;
    padding: 0px 10px 0px 35px;
  }

  #action .buttom-text .text h3 {
    font-size: 25px;
  }

  #action .buttom-text .text p {
    font-size: 15px;
  }
}
.thumbnail-age {
  margin: 0px 40px 0px 40px;
}

@media only screen and (min-width: 1440px) {
  #after-reasons {
    margin: 0px 0px 0px 0px !important;
  }
}

.detail-wrapper {
  text-align: center;
}

#after-reasons {
  height: 562px;
  padding: 50px 0px 0px 0px;
  margin: 50px 0px 0px 0px;
}

.after-reasons {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("https://api.paideia.id/api/files/public/5bc1e620dc3c45b1be6dd4493698a22eVector4.png");
}

.after-reasons h2 {
  font-size: 45px;
  font-family: "PoppinsBold";
  color: #000;
  line-height: 45px;
  margin-bottom: 30px;
  margin-top: -20px;
  text-shadow: 0px 2px 2px rgba(103, 103, 103, 20);
}

.after-reasons p {
  font-family: "PoppinsRegular";
  font-size: 25px;
  color: #000;
  margin-top: -20px;
  padding-right: 160px;
  line-height: 40px;
}

.after-reasons p b {
  font-family: "PoppinsSemiBold";
}

@media only screen and (max-width: 700px) {
  #after-reasons {
    height: auto;
    width: 100%;
    margin: 50px 0px 0px 0px;
    padding: 0px 10px 0px 10px;
    background-image: none;
    background-color: #fcd507;
  }

  .after-reasons h2 {
    font-size: 30px;
    margin-top: 50px;
  }

  .after-reasons p {
    font-size: 18px;
    margin-bottom: 50px;
    padding-right: 10px;
  }
}

@media (max-width: 991px) {
  #after-reasons {
    height: auto;
    width: 100%;
    margin: 0px 0px 0px 0px;
    padding: 70px 10px 70px 10px;
    background-image: none;
    background-color: #fcd507;
  }
  .after-reasons .kutip1 {
    margin: -20px 10px -40px 0px !important;
    top: 20px;
    width: 10vw;
    height: 7vw;
  }
}

#action {
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 31px;
  background-color: #74cccf;
}

@media only screen and (max-width: 700px) {
  #action {
    height: auto;
  }

  #action .card-place {
    margin: 0px 0px 0px 15px;
  }
}

.discount {
  position: absolute;
  z-index: 1;
  right: 5px;
  bottom: -15px;
}

#action .card {
  border-radius: 8px;
  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.1);
  margin: 0rem 1rem 1rem 0rem;
  background-color: #dcfdfe;
  height: auto;
}

#action .card2 {
  border-radius: 8px;
  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.1);
  margin: 0rem 1rem 1rem 0rem;
  padding-top: 3px;
  background-color: #dcfdfe;
  height: 1340px;
}

.card2 .wrapper-header h5 {
  color: #000;
  font-size: 31px;
}

.card2 .wrapper-header p b {
  color: #ef4651;
  font-size: 12px;
}

.card-1,
.card-2,
.card-3,
.card-4,
.card-5,
.card-6,
.card-7,
.card-8,
.card-9,
.card-10,
.card-11,
.card-12,
.card-13,
.card-14,
.card-15,
.card-16,
.card-17,
.card-18,
.card-19,
.card-20,
.card-21,
.card-22,
.card-23,
.card-24,
.card-25,
.card-26,
.card-27,
.card-28,
.card-29,
.card-30,
.card-31,
.card-32,
.card-33,
.card-34,
.card-35,
.card-36,
.card-37,
.card-38,
.card-39,
.card-40,
.card-41,
.card-42,
.card-43,
.card-44,
.card-45,
.card-46,
.card-47 {
  background-color: rgb(255, 255, 255);
  margin: 0px 0px 15px 10px !important;
  padding: 10px 0px 10px 10px !important;
  border-radius: 10px;
}

.card .wrapper-header h5 {
  color: #000;
  font-size: 31px;
}

.card .wrapper-header p b {
  color: #ef4651;
  font-size: 12px;
}

@media only screen and (max-width: 700px) {
  #action .card {
    height: auto;
  }

  .card .wrapper-header {
    text-align: center;
  }

  .card .wrapper-header h5 {
    color: #000;
    font-size: 31px;
  }

  .card .wrapper-header p b {
    color: #ef4651;
    font-size: 12px;
  }

  #action .card2 {
    height: auto;
  }

  .card2 .wrapper-header {
    text-align: center;
  }

  .card2 .wrapper-header h5 {
    color: #000;
    font-size: 31px;
  }

  .card2 .wrapper-header p b {
    color: #ef4651;
    font-size: 12px;
  }

  .discount {
    position: absolute;
    z-index: 1;
    height: 20vw;
    width: 20vw;
    right: 265px;
  }
}

#action ul {
  padding: 0px;
}

#action .card p {
  font-size: 14px;
}

#action ul li {
  list-style: none;
  font-size: 14px;
}

#action .wrapper-testimony .btn-all {
  font-weight: 600;
  height: 50px;
  line-height: 10px;
  padding: 0px 35px 0px 35px;
  background: #ed4954;
  border: none;
  outline: none;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 42px;
  right: 0;
  top: 0;
  color: #ffffff;
  width: auto;
  font-size: 20px;
  margin: -10px 0px 10px 0px;
}

.font-size-1v {
  font-size: 1vw;
}

.font-size-2v {
  font-size: 2vw;
}

.font-size-3v {
  font-size: 3vw;
}

.font-size-4v {
  font-size: 4vw;
}

.font-size-5v {
  font-size: 5vw;
}

.font-size-6v {
  font-size: 6vw;
}

.commitement-text {
  font-size: 35px;
  letter-spacing: 10px;
}

.flex-footer {
  display: flex;
  justify-content: flex-start;
}

.item {
  margin-right: 20px;
}

.flex-footer img {
  width: 50px;
  height: 50px;
}

.line-bottom {
  margin-top: 120px;
}

.sosmed {
  padding: 0;
  margin-top: -5px;
}

.sosmed li {
  display: inline;
  margin-right: 20px;
}

.sosmed img {
  width: 17px;
}

#topnav-menu-content a:hover {
  font-weight: bold !important;
}

.landing-footer a:hover {
  color: #74cccf !important;
}

footer p {
  padding: 0px 50px 0px 0px;
  font-size: 15px;
}

@media only screen and (max-width: 700px) {
  #topnav-menu-content a:active {
    font-weight: bold !important;
  }

  .landing-footer a:active {
    color: #74cccf !important;
  }

  footer p {
    padding: 0px 0px 0px 0px;
  }
}

#action .wrapper-testimony p {
  font-family: "PoppinsBold";
  padding: 0px 5px 0px 0px;
  font-size: 19px;
}

#action .wrapper-testimony .card-1 ul {
  margin-top: -15px !important;
}

#action .wrapper-testimony .card-1,
.card-2,
.card-3,
.card-4,
.card-5,
.card-6,
.card-7,
.card-8,
.card-9,
.card-10,
.card-11,
.card-12,
.card-13,
.card-14,
.card-15,
.card-16,
.card-17,
.card-18,
.card-19,
.card-20,
.card-21,
.card-22,
.card-23,
.card-24,
.card-25,
.card-26,
.card-27,
.card-28,
.card-29,
.card-30,
.card-31,
.card-32,
.card-33,
.card-34,
.card-35,
.card-36,
.card-37,
.card-38,
.card-39,
.card-40,
.card-41,
.card-42,
.card-43,
.card-44,
.card-45,
.card-46,
.card-47 ul li {
  font-size: 19px;
}

#action .wrapper-testimony .card-1 {
  height: auto;
}

#action .wrapper-testimony .card-2 {
  height: 185px;
}

#action .wrapper-testimony .card-3 {
  height: 190px;
}

#action .wrapper-testimony .card-4 {
  height: 105px;
}

#action .wrapper-testimony .card-5 {
  height: 110px;
}

#action .wrapper-testimony .card-6 {
  height: 185px;
}

#action .wrapper-testimony .card-7 {
  height: 190px;
}

#action .wrapper-testimony .card-8 {
  height: 110px;
}

#action .wrapper-testimony .card-9 {
  height: 185px;
}

#action .wrapper-testimony .card-10 {
  height: 190px;
}

#action .wrapper-testimony .card-11 {
  height: 110px;
}

#action .wrapper-testimony .card-12 {
  height: 190px;
}

#action .wrapper-testimony .card-13 {
  height: 205px;
}

#action .wrapper-testimony .card-14 {
  height: 130px;
}

#action .wrapper-testimony .card-15 {
  height: 110px;
}

#action .wrapper-testimony .card-16 {
  height: 190px;
}

#action .wrapper-testimony .card-17 {
  height: 220px;
}

#action .wrapper-testimony .card-18 {
  height: 110px;
}

#action .wrapper-testimony .card-19 {
  height: 190px;
}

#action .wrapper-testimony .card-20 {
  height: 220px;
}

#action .wrapper-testimony .card-21 {
  height: 110px;
}

#action .wrapper-testimony .card-22 {
  height: 220px;
}

#action .wrapper-testimony .card-23 {
  height: 220px;
}

#action .wrapper-testimony .card-24 {
  height: 135px;
}

#action .wrapper-testimony .card-25 {
  height: 130px;
}

#action .wrapper-testimony .card-26 {
  height: 220px;
}

#action .wrapper-testimony .card-27 {
  height: 220px;
}

#action .wrapper-testimony .card-28 {
  height: 135px;
}

#action .wrapper-testimony .card-29 {
  height: 130px;
}

#action .wrapper-testimony .card-30 {
  height: 220px;
}

#action .wrapper-testimony .card-31 {
  height: 220px;
}

#action .wrapper-testimony .card-32 {
  height: 135px;
}

#action .wrapper-testimony .card-33 {
  height: 130px;
}

#action .wrapper-testimony .card-34 {
  height: 160px;
}

#action .wrapper-testimony .card-35 {
  height: 245px;
}

#action .wrapper-testimony .card-36 {
  height: 245px;
}

#action .wrapper-testimony .card-37 {
  height: 135px;
}

#action .wrapper-testimony .card-38 {
  height: 130px;
}

#action .wrapper-testimony .card-39 {
  height: 245px;
}

#action .wrapper-testimony .card-40 {
  height: 245px;
}

#action .wrapper-testimony .card-41 {
  height: 135px;
}

#action .wrapper-testimony .card-42 {
  height: 130px;
}

#action .wrapper-testimony .card-43 {
  height: 160px;
}

#action .wrapper-testimony .card-44 {
  height: 245px;
}

#action .wrapper-testimony .card-45 {
  height: 245px;
}

#action .wrapper-testimony .card-46 {
  height: 135px;
}

#action .wrapper-testimony .card-47 {
  height: 130px;
}

@media only screen and (max-width: 700px) {
  #action .wrapper-testimony .card-1,
  .card-2,
  .card-3,
  .card-4,
  .card-5,
  .card-6,
  .card-7,
  .card-8,
  .card-9,
  .card-10,
  .card-11,
  .card-12,
  .card-13,
  .card-14,
  .card-15,
  .card-16,
  .card-17,
  .card-18,
  .card-19,
  .card-20,
  .card-21,
  .card-22,
  .card-23,
  .card-24,
  .card-25,
  .card-26,
  .card-27,
  .card-28,
  .card-29,
  .card-30,
  .card-31,
  .card-32,
  .card-33,
  .card-34,
  .card-35,
  .card-36,
  .card-37,
  .card-38,
  .card-39,
  .card-40,
  .card-41,
  .card-42,
  .card-43,
  .card-44,
  .card-45,
  .card-46,
  .card-47 {
    height: auto !important;
    padding: 10px 10px 10px 10px !important;
  }
}

.diskon {
  position: absolute;
  z-index: 1;
  bottom: -20px;
  left: -20px;
  width: 80px;
  height: 80px;
}

@media (max-width: 320px) {
  .diskon {
    width: 60px;
    height: 60px;
    left: -35px !important;
  }
}
</style>

<template>
  <div>
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <Header active-page="curriculum"></Header>
    <div v-scroll-spy>
      <!-- hero section start -->
      <section class="section hero-section" id="home-header">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12 col-md-8 col-sm-10 ml-lg-auto">
              <div class="mb-0 mt-5 mr-5 mt-lg-0 text-center">
                <img
                  class="image-home"
                  src="@/assets/images/covecoders/kiddy.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <!-- end container -->
      </section>
      <!-- hero section end -->

      <section class="after-reasons" id="after-reasons">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <img
                class="kutip1"
                src="@/assets/images/covecoders/pages/quote1.svg"
                alt=""
              />
              <h2>
                Our
                <span style="color:#74cccf;">carefully crafted</span> programs
                will be catering to their
                <span style="color:#47B77E">developmental needs</span>,
                delivered with
                <span style="color:#ED4954;">meaningful methodologies.</span>
              </h2>
              <p class="dark">
                We hope to effectively equip them to grasp required
                <b>relations</b>, <b>patterns</b>, <b>reason</b>, and
                <b>principles</b> through <b>coding</b>,
                <b>visualizations</b> and <b>animations</b>, even as they grow
                to see the <b>big picture</b> and <b>connect the dots</b> at
                their levels.
              </p>
              <img
                class="kutip2"
                src="@/assets/images/covecoders/pages/quote2.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section id="action">
        <div class="container">
          <div class="wrapper-thumbnail">
            <div class="row thumbnail-icon">
              <a
                class="nav-link thumbnail"
                @click.prevent="setActive('home')"
                :class="{ active: isActive('home') }"
                href="#home"
              >
                <h2>Kiddy</h2>
                <p>4-6 years old</p>
              </a>
              <a
                class="nav-link thumbnail"
                @click.prevent="setActive('menu2')"
                :class="{ active: isActive('menu2') }"
                href="#menu2"
              >
                <h2>Junior</h2>
                <p>7-10 years old</p>
              </a>
              <a
                class="nav-link thumbnail"
                @click.prevent="setActive('menu3')"
                :class="{ active: isActive('menu3') }"
                href="#menu3"
              >
                <h2>Upper</h2>
                <p>11-14 years old</p>
              </a>
              <a
                class="nav-link thumbnail"
                @click.prevent="setActive('menu4')"
                :class="{ active: isActive('menu4') }"
                href="#menu4"
              >
                <h2>Senior</h2>
                <p>15-17 years old</p>
              </a>
            </div>
          </div>
          <div class="row">
            <div class="tab-content py-3" id="myTabContent">
              <div
                class="tab-pane fade wrapper-testimony"
                :class="{ 'active show': isActive('home') }"
                id="home"
              >
                <div class="column col-sm-12 mt-3">
                  <div class="row test">
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-1.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">3-week Camp</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >3 days a week (9 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>9 Concepts</li>
                                    <li>9 Activities</li>
                                    <li>3 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-2 auto">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                    <li>Literacy</li>
                                    <li>Game App Development</li>
                                  </ul>
                                </div>
                                <div class="card-3 auto">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Creativity</li>
                                    <li>Decision Making</li>
                                    <li>Cognitive Flexibility</li>
                                  </ul>
                                </div>
                                <div class="card-4">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-5">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>3-week Coding Foundation</li>
                                  </ul>
                                </div>
                                <div class="curriculum-button2 text-center">
                                  <p
                                    style="color:#EF4651; font-size:21px; margin-top:30px; text-decoration:line-through;"
                                  >
                                    <span class="regular">IDR 2,499,999</span>
                                  </p>
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-top:-15px; font-size:31px"
                                  >
                                    IDR 1,999,000
                                  </h5>
                                  <p
                                    class="extrabold"
                                    style="color:#EF4651; margin-top:-10px; font-size:23px"
                                  >
                                    <b class="bold">USD 140.78</b>
                                  </p>
                                  <button
                                    class="btn-all mt-2"
                                    @click="onGoing()"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-sm-2" style="position:relative;">
                            <img
                              class="diskon"
                              src="@/assets/images/covecoders/pages/Discount.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-1.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">3-month Class</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >twice a week (24 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>19 Concepts</li>
                                    <li>24 Activities</li>
                                    <li>5 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-6">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                    <li>Literacy</li>
                                    <li>Game App Development</li>
                                    <li>Digital Citizenship</li>
                                  </ul>
                                </div>
                                <div class="card-7">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Creativity</li>
                                    <li>Decision Making</li>
                                    <li>Cognitive Flexibility</li>
                                    <li>Computational Concepts</li>
                                  </ul>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-8">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                  </ul>
                                </div>
                                <div
                                  class="curriculum-button2 text-center"
                                  style="margin-top:55px"
                                >
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-bottom:50px; font-size:31px"
                                  >
                                    COMING SOON!
                                  </h5>
                                  <button
                                    style="background-color:#B3B3B3"
                                    class="btn-all mt-2"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-1.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">6-month Class</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >twice a week (48 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>38 Concepts</li>
                                    <li>48 Activities</li>
                                    <li>8 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-9">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                    <li>Literacy</li>
                                    <li>Game App Development</li>
                                    <li>Digital Citizenship</li>
                                  </ul>
                                </div>
                                <div class="card-10">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Creativity</li>
                                    <li>Decision Making</li>
                                    <li>Cognitive Flexibility</li>
                                    <li>
                                      Computational Concepts and <br />Practices
                                    </li>
                                  </ul>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-11">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Game Development</li>
                                  </ul>
                                </div>
                                <div
                                  class="curriculum-button2 text-center"
                                  style="margin-top:55px"
                                >
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-bottom:50px; font-size:31px"
                                  >
                                    COMING SOON!
                                  </h5>
                                  <button
                                    style="background-color:#B3B3B3"
                                    class="btn-all mt-2"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade wrapper-testimony"
                :class="{ 'active show': isActive('menu2') }"
                id="menu2"
              >
                <div class="column col-sm-12 mt-3">
                  <div class="row test">
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-2.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">3-week Camp</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >3 days a week (9 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>9 Concepts</li>
                                    <li>9 Activities</li>
                                    <li>3 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-12">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                    <li>Literacy</li>
                                    <li>Game App Development</li>
                                  </ul>
                                </div>
                                <div class="card-13">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Complex Problem Solving</li>
                                    <li>Critical Thinking</li>
                                    <li>Decision Making</li>
                                  </ul>
                                </div>
                                <div class="card-14">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-15">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>3-week Coding Foundation</li>
                                  </ul>
                                </div>
                                <div class="curriculum-button2 text-center">
                                  <p
                                    style="color:#EF4651; font-size:21px; text-decoration: line-through;"
                                  >
                                    <span class="regular">IDR 2,499,999</span>
                                  </p>
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-top:-15px; font-size:31px"
                                  >
                                    IDR 1,999,000
                                  </h5>
                                  <p
                                    class="bold"
                                    style="color:#EF4651; margin-top:-10px; font-size:23px"
                                  >
                                    <b class="bold">USD 140.78</b>
                                  </p>
                                  <button
                                    class="btn-all mt-2"
                                    @click="onGoing()"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-sm-2" style="position:relative;">
                            <img
                              style="position:absolute; z-index:1; bottom:-20px; left:-20px; width:80px; height:80px"
                              src="@/assets/images/covecoders/pages/Discount.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-2.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">3-month Class</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >twice a week (24 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>21 Concepts</li>
                                    <li>24 Activities</li>
                                    <li>5 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-16">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                    <li>Literacy</li>
                                    <li>Mobile App Development</li>
                                    <li>Digital Citizenship</li>
                                  </ul>
                                </div>
                                <div class="card-17">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Complex Problem Solving</li>
                                    <li>Critical Thinking</li>
                                    <li>Decision Making</li>
                                    <li>Judgment</li>
                                    <li>Computational Concepts</li>
                                  </ul>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Basic Programming Concepts</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-18">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                  </ul>
                                </div>
                                <div
                                  class="curriculum-button2 text-center"
                                  style="margin-top:35px"
                                >
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-bottom:45px; font-size:31px"
                                  >
                                    COMING SOON!
                                  </h5>
                                  <button
                                    style="background-color:#B3B3B3"
                                    class="btn-all mt-2"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-2.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">6-month Class</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >twice a week (48 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>42 Concepts</li>
                                    <li>48 Activities</li>
                                    <li>6 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-19">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                    <li>Literacy</li>
                                    <li>Game App Development</li>
                                    <li>Digital Citizenship</li>
                                  </ul>
                                </div>
                                <div class="card-20">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Complex Problem Solving</li>
                                    <li>Critical Thinking</li>
                                    <li>Decision Making</li>
                                    <li>Judgment</li>
                                    <li>
                                      Computational Concepts and <br />Practices
                                    </li>
                                  </ul>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Basic Programming Concepts</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-21">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Game Development</li>
                                  </ul>
                                </div>
                                <div
                                  class="curriculum-button2 text-center"
                                  style="margin-top:35px"
                                >
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-bottom:40px; font-size:31px"
                                  >
                                    COMING SOON!
                                  </h5>
                                  <button
                                    style="background-color:#B3B3B3"
                                    class="btn-all mt-2"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade wrapper-testimony"
                :class="{ 'active show': isActive('menu3') }"
                id="menu3"
              >
                <div class="column col-sm-12 mt-3">
                  <div class="row test">
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-3.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">3-week Camp</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >3 days a week (9 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>9 Concepts</li>
                                    <li>9 Activities</li>
                                    <li>3 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-22">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                    <li>Mobile App Development</li>
                                  </ul>
                                </div>
                                <div class="card-23">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Design Thinking</li>
                                    <li>Creativity</li>
                                    <li>Critical Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-24">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Game Development</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-25">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>3-week Coding Foundation</li>
                                  </ul>
                                </div>
                                <div class="curriculum-button2 text-center">
                                  <p
                                    style="color:#EF4651; font-size:21px; margin-top:20px; margin-bottom:0px; text-decoration: line-through;"
                                  >
                                    <span class="regular">IDR 2,999,999</span>
                                  </p>
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-top:0px; font-size:31px"
                                  >
                                    IDR 2,399,000
                                  </h5>
                                  <p
                                    class="bold"
                                    style="color:#EF4651; margin-top:-10px; font-size:23px"
                                  >
                                    <b class="bold">USD 168.96</b>
                                  </p>
                                  <button
                                    class="btn-all mt-2"
                                    @click="onGoing()"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-sm-2" style="position:relative;">
                            <img
                              style="position:absolute; z-index:1; bottom:-20px; left:-20px; width:80px; height:80px"
                              src="@/assets/images/covecoders/pages/Discount.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-3.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">3-month Class</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >twice a week (24 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>21 Concepts</li>
                                    <li>24 Activities</li>
                                    <li>5 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-26">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Mobile App Development</li>
                                    <li>Digital Citizenship</li>
                                    <li>Literacy</li>
                                    <li>Design Thinking</li>
                                    <li>Digital Security & Smartness</li>
                                  </ul>
                                </div>
                                <div class="card-27">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Design Thinking</li>
                                    <li>Creativity</li>
                                    <li>Critical Thinking</li>
                                    <li>Emotional Intelligence</li>
                                    <li>Cognitive Flexibility</li>
                                    <li>Computational Practicess</li>
                                  </ul>
                                </div>
                                <div class="card-28">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Advanced Concepts</li>
                                    <li>Game Development</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-29">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Game Development</li>
                                  </ul>
                                </div>
                                <div
                                  class="curriculum-button2 text-center"
                                  style="margin-top:50px"
                                >
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-bottom:65px; font-size:31px"
                                  >
                                    COMING SOON!
                                  </h5>
                                  <button
                                    style="background-color:#B3B3B3"
                                    class="btn-all"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-place col-xl-4">
                      <div class="card">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-3.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">6-month Class</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >twice a week (48 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>42 Concepts</li>
                                    <li>48 Activities</li>
                                    <li>6 Projects + 1 Hackathon</li>
                                  </ul>
                                </div>
                                <div class="card-30">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Mobile App Development</li>
                                    <li>Digital Citizenship</li>
                                    <li>Computational Thinking</li>
                                    <li>Design Thinking</li>
                                    <li>Digital Security & Smartness</li>
                                  </ul>
                                </div>
                                <div class="card-31">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Design Thinking</li>
                                    <li>Creativity</li>
                                    <li>Critical Thinking</li>
                                    <li>Coordination with Others</li>
                                    <li>Emotional Intelligence</li>
                                    <li>Cognitive Flexibility</li>
                                  </ul>
                                </div>
                                <div class="card-32">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Advanced Concepts</li>
                                    <li>Game Development</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-33">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Game Development</li>
                                    <li>App Development</li>
                                  </ul>
                                </div>
                                <div
                                  class="curriculum-button2 text-center"
                                  style="margin-top:50px"
                                >
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-bottom:45px; font-size:31px"
                                  >
                                    COMING SOON!
                                  </h5>
                                  <button
                                    style="background-color:#B3B3B3"
                                    class="btn-all mt-2"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade wrapper-testimony"
                :class="{ 'active show': isActive('menu4') }"
                id="menu4"
              >
                <div class="column col-sm-12 mt-3">
                  <div class="row test">
                    <div class="card-place col-xl-4">
                      <div class="card2">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-4.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">3-week Camp</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >3 days a week (9 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-34">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>9 Concepts</li>
                                    <li>9 Activities</li>
                                    <li>3 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-35">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Computational Thinking</li>
                                    <li>Mobile App Development</li>
                                  </ul>
                                </div>
                                <div class="card-36">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Design Thinking</li>
                                    <li>Creativity</li>
                                    <li>Critical Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-37">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Game Development</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-38">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>3-week Coding Foundation</li>
                                  </ul>
                                </div>
                                <div class="curriculum-button2 text-center">
                                  <p
                                    style="color:#EF4651; font-size:21px;   text-decoration: line-through;"
                                  >
                                    <span class="regular">IDR 2,999,999</span>
                                  </p>
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-top:-15px; font-size:31px"
                                  >
                                    IDR 2,399,000
                                  </h5>
                                  <p
                                    class="bold"
                                    style="color:#EF4651; margin-top:-5px; font-size:23px"
                                  >
                                    <b class="bold">USD 168.96</b>
                                  </p>
                                  <button
                                    class="btn-all mt-2"
                                    @click="onGoing()"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-sm-2" style="position:relative;">
                            <img
                              style="position:absolute; z-index:1; bottom:-20px; left:-20px; width:80px; height:80px"
                              src="@/assets/images/covecoders/pages/Discount.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-place col-xl-4">
                      <div class="card2">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-4.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">3-month Class</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >twice a week (24 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-1" style="height:160px">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>24 Concepts</li>
                                    <li>24 Activities</li>
                                    <li>5 Projects</li>
                                  </ul>
                                </div>
                                <div class="card-39">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Mobile App Development</li>
                                    <li>Digital Citizenship</li>
                                    <li>Literacy</li>
                                    <li>Design Thinking</li>
                                    <li>Digital Security & Smartness</li>
                                  </ul>
                                </div>
                                <div class="card-40">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Design Thinking</li>
                                    <li>Creativity</li>
                                    <li>Critical Thinking</li>
                                    <li>Emotional Intelligence</li>
                                    <li>Cognitive Flexibility</li>
                                    <li>Computational Practicess</li>
                                  </ul>
                                </div>
                                <div class="card-41">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Advanced Concepts</li>
                                    <li>Game Development</li>
                                    <li>Computational Thinking</li>
                                  </ul>
                                </div>
                                <div class="card-42">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Game Development</li>
                                  </ul>
                                </div>
                                <div
                                  class="curriculum-button2 text-center"
                                  style="margin-top:40px"
                                >
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-bottom:60px; font-size:31px"
                                  >
                                    COMING SOON!
                                  </h5>
                                  <button
                                    style="background-color:#B3B3B3"
                                    class="btn-all mt-2"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-place col-xl-4">
                      <div class="card2">
                        <div
                          class="card-body"
                          style="padding:0px 20px 0px 10px"
                        >
                          <div class="table-responsive mt-4">
                            <table class="table table-centered">
                              <tbody>
                                <div class="wrapper-header col-sm-12">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <img
                                        src="@/assets/images/covecoders/embed/embed-4.svg"
                                        width="100px"
                                        height="100px"
                                        alt=""
                                      />
                                    </div>
                                    <div class="col-sm-8">
                                      <h5 class="extrabold">6-month Class</h5>
                                      <p style="margin-top:-10px">
                                        <b class="bold"
                                          >twice a week (48 sessions)</b
                                        >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-43">
                                  <p style="color:#000">
                                    <b
                                      >Concept-based Activities + Purposeful
                                      Projects:</b
                                    >
                                  </p>
                                  <ul style="color:#000">
                                    <li>45 Concepts</li>
                                    <li>48 Activities</li>
                                    <li>9 Projects + 1 Hackathon</li>
                                  </ul>
                                </div>
                                <div class="card-44">
                                  <p style="color:#000">
                                    <b>Meaningful Modules:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Mobile App Development</li>
                                    <li>Digital Citizenship</li>
                                    <li>Computational Thinking</li>
                                    <li>Design Thinking</li>
                                    <li>Digital Security & Smartness</li>
                                    <li>Phyton</li>
                                  </ul>
                                </div>
                                <div class="card-45">
                                  <p style="color:#000">
                                    <b>Improvement Areas:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Design Thinking</li>
                                    <li>Creativity</li>
                                    <li>Critical Thinking</li>
                                    <li>Coordination with Others</li>
                                    <li>Emotional Intelligence</li>
                                    <li>Cognitive Flexibility</li>
                                    <li>Computational Practices</li>
                                  </ul>
                                </div>
                                <div class="card-46">
                                  <p style="color:#000">
                                    <b>Fundamental Focus:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Advanced Concepts</li>
                                    <li>App Development</li>
                                    <li>Phyton Programming</li>
                                  </ul>
                                </div>
                                <div class="card-47">
                                  <p style="color:#000">
                                    <b>Cybernetic Certification:</b>
                                  </p>
                                  <ul style="color:#000">
                                    <li>Coding Foundation</li>
                                    <li>Game Development</li>
                                    <li>Phyton Foundation</li>
                                  </ul>
                                </div>
                                <div
                                  class="curriculum-button2 text-center"
                                  style="margin-top:40px"
                                >
                                  <h5
                                    class="bold"
                                    style="color:#EF4651; margin-bottom:60px; font-size:31px"
                                  >
                                    COMING SOON!
                                  </h5>
                                  <button
                                    style="background-color:#B3B3B3"
                                    class="btn-all w-xs mt-2"
                                  >
                                    Join Now
                                  </button>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="buttom-text">
              <div class="text">
                <!--
                <h3>
                  CLASSES START ON
                  <span style="color:#ef4651">{{
                    class_start.format("dddd, MMMM DD, YYYY")
                  }}</span>
                </h3>
              -->
                <p>*online and delivered in English</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Footer start -->
      <Footer active-page="curriculum"></Footer>
      <!-- Footer end -->
    </div>
  </div>
</template>
